import { forms } from '../data/forms';

// ============================================================
// YAŞAM PENCEREM - MERKEZİ MADDE SINIFLANDIRMA HARİTASI
//
// Amaç: Psikometrik puan üretmek değil;
// okul PDR hizmetleri için ihtiyaçları ve görüşme
// önceliklerini işlevsel biçimde sınıflandırmak.
//
// Madde numaraları forms.js dosyasındaki
// 48 maddelik orijinal sırayla eşleşir.
// ============================================================

const YASAM_CATEGORY_IDS = {

  "Aile ve Çevre": [
    2, 10, 11, 14, 17, 19, 21,
    22, 24, 29, 30, 38, 47
  ],

  "Okul ve Eğitim": [
    28, 31, 33, 35, 36, 40,
    42, 43, 44, 45, 46, 48
  ],

  "Akran ve Sosyal Yaşam": [
    4, 7, 12, 13, 15, 16, 27, 39
  ],

  "Kişisel Yaşam ve Duygular": [
    1, 3, 5, 6, 8, 9, 18,
    20, 23, 25, 26, 34, 37, 41
  ],

  "Gelecek ve Planlama": [
    32
  ]

};


// Olumlu özellik veya destek kaynağı bildiren maddeler.
// Bunlar problem sayısına eklenmeyecek.
const YASAM_POSITIVE_IDS = new Set([
  26
]);

// Tek başına psikolojik problem olarak yorumlanmaması
// gereken bağlamsal yaşam bilgileri.
const YASAM_CONTEXT_IDS = new Set([
  3, 13, 17, 24, 29, 47
]);

// Mevcut sistemde özel dikkat gerektiren maddeler.
// Listeyi şimdilik aynen koruyoruz.
const YASAM_ATTENTION_IDS = new Set([
  3, 7, 9, 11, 14,
  16, 18, 25, 33, 36
]);


// Ayrı güvenlik değerlendirmesi gerektiren madde.
const YASAM_SAFETY_ITEM_ID = 18;


// Tüm maddelerin merkezi kimlik haritası.
const YASAM_ITEM_META = Object.fromEntries(

  Object.entries(YASAM_CATEGORY_IDS).flatMap(

    ([category, ids]) => ids.map(id => [

      id,

      {
        id,

        category,

        kind:
          YASAM_POSITIVE_IDS.has(id)
            ? "positive"
            : YASAM_CONTEXT_IDS.has(id)
              ? "context"
              : "need",

        attentionLevel:
          id === YASAM_SAFETY_ITEM_ID
            ? "safety_review"
            : YASAM_ATTENTION_IDS.has(id)
              ? "review"
              : "routine"
      }

    ])

  )

);


// ============================================================
// MEVCUT HESAPLAMA FONKSİYONLARI
// ============================================================

const generateStandardCommentary = (categoryCounts, riskLevel, hasSuicideRisk) => {

  const openers = ["Yapılan değerlendirme neticesinde,", "Envanter verileri ışığında,", "Öğrencinin yanıtları incelendiğinde,"];
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  let text = pick(openers) + " öğrencinin mevcut durumuna dair veriler aşağıdadır. ";
  if (riskLevel.includes("KIRMIZI")) text += "Dikkat çeken risk faktörleri tespit edilmiştir. ";
  else text += "Genel uyum düzeyi dengeli görünmektedir. ";
  if (hasSuicideRisk) text += "\n\n⚠️ ACİL: Yaşam isteği maddesi işaretlenmiştir. Protokol uygulanmalıdır.";
  return text;
};

const getClinicianRecommendations = (riskLevel, topCategory, hasSuicideRisk) => {
  const baseRecs = ["Güven ilişkisi (rapport) tazelenmelidir.", "Aile ile işbirliği zemini aranmalıdır."];
  if (hasSuicideRisk) return ["⚠️ ACİL PROTOKOL: İntihar riski değerlendirme formu uygulanmalıdır.", "⚠️ Aile okula davet edilmeli, sağlık kuruluşuna sevk sağlanmalıdır."];
  return baseRecs;
};

export const calculateYasamPencerem = (answers) => {
  const config = { ids: [3, 7, 9, 11, 14, 16, 18, 25, 33, 36], suicideId: 18 };
  const testDef = forms.find(t => t.id === 'yasam_pencerem');

  let riskCount = 0;
  let criticalCount = 0;
  let hasItem18 = false;

  const riskList = [];

  const categoryCounts = Object.fromEntries(
    Object.keys(YASAM_CATEGORY_IDS).map(category => [category, 0])
  );

  Object.entries(answers || {}).forEach(([key, value]) => {

    const checked =
      value === true ||
      value === 'true' ||
      value === 1 ||
      value === '1';

    if (!checked) return;

    const qId = Number(key);
    const itemMeta = YASAM_ITEM_META[qId];

    if (!Number.isInteger(qId) || !itemMeta) return;

    const qText =
      testDef?.items?.find(q => Number(q.id) === qId)?.text ||
      `Madde ${qId}`;

    const isCritical =
      itemMeta.attentionLevel !== 'routine';

    if (isCritical) {
      criticalCount++;
    }

    if (qId === YASAM_SAFETY_ITEM_ID) {
      hasItem18 = true;
    }

    // İşaretlenen bütün maddeleri koru.
    // Kurumsal sıklık analizinde kullanılacak.
    riskList.push({
      id: qId,
      text: qText,
      category: itemMeta.category,
      kind: itemMeta.kind,
      attentionLevel: itemMeta.attentionLevel,
      isCritical
    });

    // Yalnız problem / ihtiyaç bildirimleri
    // problem yoğunluğunu artırır.
    if (itemMeta.kind === 'need') {

      riskCount++;

      categoryCounts[itemMeta.category]++;

    }

  });

  let summary = "DÜŞÜK RİSK"; let colorCode = "green";
  if (hasItem18) { summary = "KIRMIZI ALARM (Yaşam Riski)"; colorCode = "red"; }
  else if (criticalCount >= 3) { summary = "KIRMIZI ALARM (Çoklu Kritik)"; colorCode = "red"; }
  else if (riskCount > ((testDef?.items?.length || 50) / 3)) { summary = "YÜKSEK RİSK"; colorCode = "red"; }
  else if (criticalCount > 0 || riskCount > 5) { summary = "ORTA DÜZEY RİSK"; colorCode = "amber"; }

  const analysisText = generateStandardCommentary(categoryCounts, summary, hasItem18);
  const clinicianRecs = getClinicianRecommendations(summary, "Genel", hasItem18);
    const chartData = Object.entries(categoryCounts).map(
    ([subject, count]) => ({
      subject,
      A: count,
      fullMark: Math.max(1, riskCount)
    })
  );

  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Evrensel radar için risk seviyesini belirliyoruz
  let masterRisk = "low";
  if (summary.includes("KIRMIZI") || summary.includes("YÜKSEK")) masterRisk = "high";
  else if (summary.includes("ORTA")) masterRisk = "medium";

  // 50 soruluk envanter üzerinden risk yüzdesi (18. Madde varsa direkt 100 puan ile en üste çakılır)
  const riskScore = hasItem18 ? 100 : Math.round((riskCount / (testDef?.items?.length || 50)) * 100);

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak ve 18. Maddeyi en üste dizecek)
    riskScore: riskScore,
    masterRisk: masterRisk,
    isCritical: hasItem18, // Sistemdeki TEK GERÇEK KIRZIMI ÇİZGİ: Yaşam Riski (18. Madde)
    domain: "psychological", // Psikolojik alan

    // 2. Mevcut Detaylı Veriler (Dokunmadık)
    summary, 
    analysis: analysisText, 
    risks: riskList, 
    chartData, 
    criticalCount, 
    hasItem18, 
    colorCode, 
    clinicianRecs, 
    recommendations: "Bireysel görüşme yapılmalıdır.",
    riskLevel: masterRisk // Geriye dönük uyumluluk
  };
};